import i18n from 'i18next';

export default () => ({
  cover_art: {
    type: 'Upload',
    label: i18n.t('display-cover-art'),
    help: i18n.t('display-cover-art-help'),
    uploadType: 'image',
    permittedFormats: 'image/*',
    hasReplaceUploadButton: true,
    replaceUploadButtonText: i18n.t('replace-cover-art'),
    uploadButtonText: i18n.t('display-cover-art-upload'),
    removeButtonText: i18n.t('remove-cover-art'),
    maxUploadSize: 10,
  },
  is_expanded_only: {
    type: 'Boolean',
    label: i18n.t('display-properties-label'),
    help: i18n.t('display-properties-help'),
    labelText: i18n.t('display-properties-label-text'),
  },
});
